import type { Validator } from '@seek/validators-js';

import type { Language } from 'src/types';

export function createFieldValidator<T = string>(
  validators: Array<Validator<T, any, any, any>>,
  validatorProps: Record<string, any> = {},
  locale: Language,
) {
  return async function fieldValidator(
    value: T,
    formValues: Record<string, any>,
  ) {
    let errorMsgPromise;
    const params = { value, validatorProps, formValues };

    for (const validator of validators) {
      if (validator.test(params)) {
        continue;
      }
      errorMsgPromise = validator.getErrorMessage(params, locale);
      break;
    }

    return await errorMsgPromise;
  };
}
